import { html, render } from "lit-html";
import connect from "../../../shared/data-store/connect";
import { store } from "./DataStore";

import "./PriceFilter";
import "./CancelationFilter";
import { FilterWithInitialLoadingStyle } from "../FilterWithInitialLoadingStyle";

customElements.define(
	"esc-favorites-price-filter-section",
	class extends connect(FilterWithInitialLoadingStyle, store) {
		update(_, { priceFiltersVisible }) {
			this.style.display = priceFiltersVisible ? "" : "none";
			render(
				html`
					<esc-favorites-price-filter
						class="price-filter"
					></esc-favorites-price-filter>
					<esc-favorites-cancelation-filter></esc-favorites-cancelation-filter>
				`,
				this,
			);

			// remove min-height after rendering component
			this.removeInitialLoading();
		}
	},
);
